import Icon from '../../../components/AppIcon';

const StatsOverview = () => {
  const stats = [
    {
      id: 1,
      label: "Descuentos Usados",
      value: "23",
      icon: "Tag",
      color: "var(--color-success)",
      bgColor: "bg-success/10",
      trend: "+5 este mes"
    },
    {
      id: 2,
      label: "Ahorro Total",
      value: "$145.000",
      icon: "TrendingDown",
      color: "var(--color-primary)",
      bgColor: "bg-primary/10",
      trend: "COP ahorrados"
    },
    {
      id: 3,
      label: "Negocios Visitados",
      value: "12",
      icon: "Store",
      color: "var(--color-secondary)",
      bgColor: "bg-secondary/10",
      trend: "Diferentes lugares"
    },
    {
      id: 4,
      label: "Referidos Activos",
      value: "8",
      icon: "Users",
      color: "var(--color-accent)",
      bgColor: "bg-accent/10",
      trend: "40 puntos ganados"
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats?.map((stat) => (
        <div key={stat?.id} className="bg-card rounded-lg border border-border p-6 shadow-card hover:shadow-modal transition-shadow">
          <div className="flex items-start justify-between mb-4">
            <div className={`flex items-center justify-center w-12 h-12 rounded-lg ${stat?.bgColor}`}>
              <Icon name={stat?.icon} size={24} color={stat?.color} />
            </div>
          </div>
          <div>
            <p className="text-2xl font-bold text-foreground mb-1">{stat?.value}</p>
            <p className="text-sm font-medium text-foreground mb-1">{stat?.label}</p>
            <p className="text-xs text-muted-foreground">{stat?.trend}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsOverview;